const points = [
  {
    title: 'Деньги — не единственный фактор',
    desc: 'Зарплата важна, но после определённого уровня она перестаёт быть главным мотиватором. Сотруднику также важны признание, развитие, самостоятельность и понимание смысла работы.',
  },
  {
    title: 'Одинаковый подход не работает',
    desc: 'Что мотивирует одного сотрудника, может демотивировать другого. Руководителю необходимо понимать индивидуальные факторы мотивации каждого члена команды.',
  },
  {
    title: 'Руководитель формирует среду',
    desc: 'Атмосфера в команде, стиль коммуникации и управленческие привычки руководителя напрямую влияют на вовлечённость сотрудников.',
  },
  {
    title: 'Признание меняет поведение',
    desc: 'Качественная обратная связь и признание результатов — один из самых сильных и при этом недооценённых инструментов влияния на мотивацию.',
  },
  {
    title: 'Отсутствие целей снижает инициативу',
    desc: 'Когда сотрудник не понимает, к какому результату движется команда, его мотивация снижается. Ясные цели создают энергию для действий.',
  },
  {
    title: 'Ответственность связана с самостоятельностью',
    desc: 'Сотрудники более мотивированы, когда у них есть зона ответственности и право принимать решения в её рамках, а не просто исполнять указания.',
  },
];

export default function LeadershipMotivation() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Лидерство и мотивация команды
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Как руководителю добиваться вовлечённости сотрудников — не только через зарплату
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {points.map((point) => (
            <div key={point.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6">
              <h3 className="font-bold text-gray-900 text-sm mb-2">{point.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{point.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}